import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';

@NgModule({
    declarations: [
        DashboardComponent,
    ],
    imports: [
        CommonModule, DashboardRoutingModule,
        ],

    exports: [

    ],
})

export class DashboardModule {
}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/pages/dashboard/dashboard.module.ts